import React from 'react';
import { FaArrowLeft, FaExternalLinkSquareAlt, FaLongArrowAltRight, FaTv} from 'react-icons/fa';
import { peerlessDataForVids} from '../Components/PeerlessData';
import Slider from 'react-slick';
import { Tooltip } from 'react-tooltip';



const  AppWebDevPage = ({setNavLinks, handleImageExpansion, vidLinkSettings, slidesToShow2, setSlidesToShow2, sliderState7, setSliderState7, handleAfterChange7}) => {


  React.useEffect(() => {
    // retrieve slider state from local storage on component mount
    const storedState = JSON.parse(sessionStorage.getItem('sliderState7'));
    if(storedState){setSliderState7(storedState)}
    const handleResize = () => {
      if (window.innerWidth >= 1030) {
        setSlidesToShow2(2);
      } else if (window.innerWidth >= 600) {
        setSlidesToShow2(2);
      } else if (window.innerWidth >= 300) {
        setSlidesToShow2(1);
      } else {
        setSlidesToShow2(1);
      }

      
    };

    handleResize()
    window.addEventListener('resize', handleResize);
    
    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [setSlidesToShow2, setSliderState7]);

    const settings = {

        dots: false,
        Infinity: true,
        slidesToShow: slidesToShow2,
        slidesToScroll: 1,
        lazyLoad: true,
        Speed: 200,
        swipe: true,
        swipeToSlide: true,

       
    }


  return (
    <div className='container-fluid'> 
            <div className='close-window-icon' ><FaArrowLeft color='#1b2328' onClick={()=>{
              
              setNavLinks({serviceLink: true})
              sessionStorage.setItem("currentSession", JSON.stringify({serviceLink: true}));
              }}/> </div>
            <h1 className='title'><FaTv color='#1b2328' /> App & Web Development </h1>



             {/* App Web Dev */}
        <div className="hair-service-container">

                <h1>Slide to see more <FaLongArrowAltRight/></h1>

                <Slider {...settings} afterChange={handleAfterChange7} initialSlide={sliderState7.currentSlide}>

                        {

                        peerlessDataForVids.map((vidLink)=>{

                            return(
                              <article className='hair-service-card' key={vidLink.id} > 
                                        
                              <div className="hair-service-img-container">
                                  <img src={require(`../Images/ServiceImages/${vidLink.folder}/${vidLink.image}`)} alt="videos"/>
                              </div>

                                  <div className="hair-service-details">
                                   
                                      <p>{vidLink.name} 
                                      
                                          <a href={vidLinkSettings(vidLink.id)} target='_blank' rel='noopenner noreferrer' data-tooltip-id='my-tooltip' data-tooltip-content="View Video">
                                            <Tooltip id='my-tooltip'/>
                                          
                                          <FaExternalLinkSquareAlt color = "white"/>
                                          </a> 
                                      
                                      
                                      </p>
                                   

                                  
                                  </div>

                              
                  
                      </article>
                            )

                        })
                        }

                </Slider>
        </div>

   
             
    </div>
  )
}

export default AppWebDevPage;